export const translation_hn = {
    heading: "टाटा स्ट्राइव | कार्य पथ",
    subHeading: "टाटा ट्रस्ट की कौशल विकास पहल ",
    partnership: "टाटा स्ट्राइव द्वारा विकसित ",
    poweredBy: "टाटा कम्युनिकेशंस द्वारा संचालित",
    welcomeText: "अपनी रुचियों की खोज करें और अपने करियर से मेल करें!",
    mobileNumber: "मोबाइल नंबर",
    dob: "जन्म की तारीख",
    otp: "ओ टी पी पॉए ",
    enterOTP: "OTP डालें",
    validateOTP: "OTP सत्यापित  करें",
    resendOTP: "OTP दुबारा पाएं",
    form_heading: "चलिए शुरुवात करते हैं ! कृपया अपने बारें में बताएं!",
    firstName: "प्रथम नाम",
    firstNamePlaceHolder: "प्रथम नाम दर्ज करें",
    lastName: "उपनाम (टाइटल)",
    lastNamePlaceHolder: "अंतिम नाम दर्ज करो",
    qualification: "योग्यता (शिक्षा)",
    gender: "लिंग",
    pincode: "पिन कोड",
    pincodePlaceHolder:"मान्य पिनकोड दर्ज करें",
    village: "गाँव",
    villagePlaceHolder:"गांव का नाम दर्ज करें",
    district: "जिला",
    districtPlaceHolder:" जिला चुनें",
    districtPinPlaceHolder:"मान्य पिनकोड दर्ज करें",

    mailId: "मेल आईडी",
    mailIdPlaceHolder:"ईमेल आईडी दर्ज करें",
    mandatoryFields: "*अनिवार्य क्षेत्र",
    save: "सहेजें",
    mobileInputError: "* बिल्कुल 10 अंक",
    pincodeInputError: "* बिल्कुल 6 अंक",
    onlyNumbersError: "* केवल नंबर",
    onlyCharError: "* केवल अक्षर",
    noSpecialCharError: "* विशेष वर्ण शामिल नहीं होने चाहिए",
    mailError: "* अमान्य मेल आईडी",
    dobError: "* आयु 16 वर्ष से अधिक होनी चाहिए",
    knowHowToPlayGame: "खेलने से पहले यह  जानना बहूत जरूरी है कि इसे कैसे सही तरीके से खेला जाए। जानने के लिए कृपया वीडियो देखें  ",
    letsPlayGame: "चलिए खेलते हैं। !",
    confirmDialog: "कृपया निश्चित करें। !",
    yes:"हां",
    no:"नहीं",
    invalidCode: "अमान्य ओटीपी",
    ok: "ठीक है",
    gamevideoConfirmation: "आशा है की आपने खेल को खेलने से पहले निर्देश के लिए वीडियो देख लिया होगा।",
    careervideoConfirmation: "आपने अपना करियर रिपोर्ट वीडियो जरुर देखा होगा ",
    doYouLikeThis: "क्या आपको यह पसंद है?",
    like:"पसंद",
    dislike: "नापसन्द",
    mayBe: "शायद",
    congratulations: "बधाई हो। ,",
    lookAtResults: "चलिए आपके नतीजों को देखते हैं।  ",
    AfterGameMsg: "आपने अभी जो खेल खेला है यह आपको सही व्यवसाय या नौकरी चुनने में सहायता करेगा | किसी व्यक्ति का किसी प्रकार के कार्य क्षेत्र में रूचि उसके व्यक्तित्व के विषय में बताती हैं। डॉ जॉन हॉलैंड थ्योरी के अनुसार छह प्रकार के व्यक्तित्व होते हैं जिनको हॉलैंड कोड्स से जाना जाता है। आपके जवाबों के अनुसार आपका व्यक्तित्व प्रकार / हॉलैंड कोड इस प्रकार है  ",
    watchCareerVideo: "अपने करियर की रिपोर्ट को समझने के लिए वीडियो देखें",
    clickHereButton: "यहां क्लिक करें",
    knowMoreAboutMatchingCareers : "अपने सबसे पसंदीदा व्यक्तित्व प्रकार और मेल खाने वाली करियर रुचि के बारे में जानने के लिए",
    ThankYouForPlayingGame: "खेल खेलने के लिए धन्यवाद।.",
    understandBetter: "आपको बेहतर ढंग से समझने में हमारी सहायता करें!",
    beforeChatBot: "कृपया आपको समझने में हमारी सहयता करें। आप अपने लिए  रोज़गार  या कार्य क्षेत्र के बारे जानने से एक कदम दूर हैं। आप अपने रोज़गार या कार्य क्षेत्र के बारे जानने से एक कदम दूर हैं। हम आपको कुछ परिस्थितियां बताएँगे और आपको ऐसा जवाब चुनना होगा जो आपके अनुसार सबसे उचित हो।.",
    clickToStart: "शुरू करने के लिए यहां क्लिक करें ",
    chatbotHeading: "आपको बेहतर ढंग से समझने में हमारी सहायता करने के लिए कृपया प्रश्नों को पूरा करें",
    noCoursesText: "कृपया करियर विकल्प तलाशने के लिए लिंक का अनुसरण करें !",
    explore: "अन्वेषण करना",
    resultText1: " ",
    resultText2: "यह उम्मीद की जाती है की कोई व्यक्तिविशेष अपने व्यकितत्व के अनुसार किसी कार्यक्षेत्र में सफल होगा। ज्यादा जानकारी के लिए कृपया सेक्टर पर क्लिक करें।.",
    JobRole : "नौकरी भूमिका",
    sector: "क्षेत्र",
    recommendCounsellor: "हम अनुरोध  करते हैं कि आप हमारे परामर्शदाता (कॉउंसलर)से संपर्क करें और अपनी रिपोर्ट को बेहतर ढंग से समझें।.",
    DownloadReport: "रिपोर्ट डाउनलोड करें",
    reachToCounsellorButton: "काउंसलिंग के लिए संपर्क करें ",
    thankYouForCounsellorRequest: "धन्यवाद I  हमारे काउंसलर (परामर्शदाता ) आपसे जल्द  ही संपर्क  करेंगे ",
    contactUs1: "प्रश्नों के लिए, कार्य दिवसों के दौरान टोल फ्री नंबर 18003458245 पर हमसे संपर्क करें, सुबह 10:00 बजे से शाम 05:00 बजे तक",
    csNumber: " ",
    contactUs2: " ",
    contactUs3: " ", 
    askFeedback: "क्या आपको खेल पसंद आया? ?",
    thankYouForFeedback: "आपके बहुमूल्य फीडबैक के लिए शुक्रिया !",
    dear : "प्रिय",
    alertPageResultMsg:"आपने सभी चरण पूरे कर लिए हैं, आइए आपके परिणामों पर एक नज़र डालते हैं। मूल्यांकन के लिए आपकी प्रतिक्रियाओं के आधार पर आपका व्यक्तित्व प्रकार/हॉलैंड कोड है",
    internetError: "कृपया प्रतीक्षा करें। पेज लोड हो रहा है.",
    confirmReplayOption: "जब आप खेलना समाप्त कर लेंगे,दुबारा  खेलना आपको एक नई करियर रिपोर्ट देगा । क्या आप अभी भी जारी रखना चाहते हैं?",
    ReplayGame: "खेल फिर से खेलना",
    gameVideo:"d3XG1VfU3Dg",
    beforeNameHappyText:"आपसे मिलकर खुशी हुई",
    afterNameHappyText:""  ,
    invalidPincode:"कृपया एक वैध पिनकोड प्रदान करें",
    middleNamePlaceHolder : "मध्य नाम दर्ज करें",
    middleName : "मध्य नाम",
    aadharnumber:"आधार संख्या",
    religion :"धर्म",
    category :"वर्ग",
    EconomicDescription:"आर्थिक स्थिति",
    differentlyAbled:"दिव्यांगजन",
    relocation:"पुनर्वास",
    trainingOpportunities:"प्रशिक्षण के अवसरों के बारे में अधिक जानने के लिए, इस पर क्लिक करें।",
    interestedCourse: 'इच्छुक पाठ्यक्रम',
    nearestCenter: 'निकटतम केंद्र'
};